'use client';

import { useSession } from 'next-auth/react';

import { Button } from '@/components/ui/button';
import { useModalStore } from '@/store/modal.store';

export function ParticipateButton() {
  const { setIsOpenAuthDialog } = useModalStore();
  const { data: session } = useSession();

  const handleRegisterOrRedirect = () => {
    if (session) {
      window.location.href = '/author-dashboard';
    } else {
      setIsOpenAuthDialog(true);
    }
  };

  return (
    <Button
      onClick={handleRegisterOrRedirect}
      className="bg-[#A9F84A] hover:bg-[#8EE328] mx-auto h-[50px] w-full rounded-[10px] py-[19px] font-[440] text-[17px] text-foreground flex justify-center md:max-w-[312px]"
    >
      Участвовать
    </Button>
  );
}
